var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "50pt",
    viewBox: "0 0 750 750",
    width: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 700 0 L 325 0 C 297.386719 0 275 22.386719 275 50 L 275 300 C 275 327.613281 297.386719 350 325 350 L 445.921875 350 L 428.066406 412.5 L 400 412.5 L 400 437.5 L 625 437.5 L 625 412.5 L 596.933594 412.5 L 579.078125 350 L 700 350 C 727.613281 350 750 327.613281 750 300 L 750 50 C 750 22.386719 727.613281 0 700 0 Z M 300 50 C 300 36.191406 311.191406 25 325 25 L 700 25 C 713.808594 25 725 36.191406 725 50 L 725 262.5 L 300 262.5 Z M 570.921875 412.5 L 454.078125 412.5 L 471.921875 350 L 553.078125 350 Z M 700 325 L 325 325 C 311.191406 325 300 313.808594 300 300 L 300 287.5 L 725 287.5 L 725 300 C 725 313.808594 713.808594 325 700 325 Z M 700 325 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 750 L 362.5 750 C 383.207031 750 400 733.207031 400 712.5 L 400 675 C 400 668.09375 394.40625 662.5 387.5 662.5 L 362.5 662.5 L 362.5 487.5 C 362.5 466.792969 345.707031 450 325 450 L 75 450 C 54.292969 450 37.5 466.792969 37.5 487.5 L 37.5 662.5 L 12.5 662.5 C 5.59375 662.5 0 668.09375 0 675 L 0 712.5 C 0 733.207031 16.792969 750 37.5 750 Z M 62.5 487.5 C 62.5 480.59375 68.09375 475 75 475 L 325 475 C 331.90625 475 337.5 480.59375 337.5 487.5 L 337.5 662.5 L 237.5 662.5 C 234.183594 662.5 231.007812 663.820312 228.664062 666.164062 L 219.824219 675 L 180.175781 675 L 171.335938 666.164062 C 168.992188 663.820312 165.816406 662.5 162.5 662.5 L 62.5 662.5 Z M 25 687.5 L 157.324219 687.5 L 166.164062 696.335938 C 168.507812 698.679688 171.683594 700 175 700 L 225 700 C 228.316406 700 231.492188 698.679688 233.835938 696.335938 L 242.675781 687.5 L 375 687.5 L 375 712.5 C 375 719.40625 369.40625 725 362.5 725 L 37.5 725 C 30.59375 725 25 719.40625 25 712.5 Z M 25 687.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 350 L 150 350 L 150 375 L 125 375 Z M 125 350 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 300 L 150 300 L 150 325 L 125 325 Z M 125 300 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 400 L 150 400 L 150 425 L 125 425 Z M 125 400 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 250 L 150 250 L 150 275 L 125 275 Z M 125 250 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 200 L 150 200 L 150 225 L 125 225 Z M 125 200 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 200 L 200 200 L 200 225 L 175 225 Z M 175 200 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 200 L 250 200 L 250 225 L 225 225 Z M 225 200 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 512.5 L 600 512.5 L 600 537.5 L 575 537.5 Z M 575 512.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 562.5 L 600 562.5 L 600 587.5 L 575 587.5 Z M 575 562.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 462.5 L 600 462.5 L 600 487.5 L 575 487.5 Z M 575 462.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 612.5 L 600 612.5 L 600 637.5 L 575 637.5 Z M 575 612.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 662.5 L 600 662.5 L 600 687.5 L 575 687.5 Z M 575 662.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 525 662.5 L 550 662.5 L 550 687.5 L 525 687.5 Z M 525 662.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 475 662.5 L 500 662.5 L 500 687.5 L 475 687.5 Z M 475 662.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 425 662.5 L 450 662.5 L 450 687.5 L 425 687.5 Z M 425 662.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 506.441406 84.746094 C 516.332031 84.726562 526.0625 87.3125 534.640625 92.246094 C 539.953125 95.316406 546.710938 94.082031 550.582031 89.316406 C 554.453125 84.566406 554.304688 77.695312 550.226562 73.117188 L 534.625 54.511719 L 525.578125 62.011719 C 501.292969 56.152344 475.671875 61.757812 456.050781 77.207031 C 436.429688 92.671875 424.992188 116.269531 425 141.25 C 424.976562 153.832031 427.898438 166.25 433.539062 177.5 L 455.902344 166.351562 C 447.207031 148.851562 448.171875 128.101562 458.46875 111.484375 C 468.753906 94.878906 486.894531 84.765625 506.441406 84.746094 Z M 506.441406 84.746094 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 556.597656 115 C 560.507812 122.820312 562.53125 131.445312 562.5 140.1875 C 562.496094 160.347656 551.738281 178.964844 534.28125 189.054688 C 516.835938 199.125 495.320312 199.140625 477.859375 189.070312 C 472.546875 186.007812 465.789062 187.246094 461.917969 192 C 458.046875 196.765625 458.195312 203.632812 462.273438 208.210938 L 476.8125 231.476562 L 494.460938 220.789062 C 517.84375 224.140625 541.523438 217.183594 559.375 201.714844 C 577.222656 186.253906 587.492188 163.808594 587.5 140.1875 C 587.53125 127.597656 584.609375 115.1875 578.960938 103.9375 Z M 556.597656 115 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 162.5 575 C 162.496094 563.222656 168.023438 552.125 177.429688 545.03125 C 186.835938 537.945312 199.027344 535.6875 210.351562 538.941406 L 217.234375 514.914062 C 190.546875 507.25 162 518.117188 147.164062 541.59375 C 132.320312 565.0625 134.757812 595.511719 153.125 616.335938 L 171.875 599.800781 C 165.828125 592.949219 162.5 584.132812 162.5 575 Z M 162.5 575 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 612.5 C 195.660156 612.503906 191.359375 611.757812 187.273438 610.292969 L 178.75 633.75 C 205.605469 643.445312 235.605469 633.710938 251.65625 610.109375 C 267.703125 586.5 265.722656 555.019531 246.835938 533.613281 L 228.085938 550.152344 C 237.867188 561.203125 240.253906 576.953125 234.1875 590.40625 C 228.132812 603.851562 214.75 612.5 200 612.5 Z M 200 612.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.1dcb35f4d79397e6fbd28fa3a667c697.svg";
export { ForwardRef as ReactComponent };